<template>
    <v-collapse-group>
      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <h3>{{$t('form.lot.request')}}</h3>
        </div>

        <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
          <!-- Request status -->
          <div class="a-container-form">
            <div class="a-label a-label--w-280">{{$t('form.lot.status')}}:</div>
            <p class="a-input a-input--disabled" v-t="lot.request.stateOriginal.label"></p>
            <span type="button" class="gui-btn-none-style"
                  @click="onRequestSignCheckClick()"
                  v-if="lot.hasSign">
              <img class="accreditation__reg-img" src="@/assets/img/static/b-icon_edit.svg" alt="">
            </span>
          </div>

          <!-- Confirmed status -->
          <div class="a-container-form" v-if="lot.request.confirmedState">
            <div class="a-label a-label--w-280">{{$t('form.lot.confirmed-request-status')}}:</div>
            <label class="a-input a-input--disabled u-red-color">{{$t(lot.request.confirmedState.label)}}</label>
          </div>

          <!-- Rejection reason -->
          <div class="a-container-form" v-if="lot.request.permissions.CAN_SEE_PUBLIC_LOT_REQUEST_REASON && lot.request.state.DECLINED">
            <div class="a-label a-label--w-280">{{$t('form.lot.reason-for-rejection')}}:</div>
            <p class="a-input a-input--disabled ">
              {{lot.request.reason}}
            </p>
          </div>

          <!-- regulations reason to rejects -->
          <div class="a-container-form" v-if="lot.request.permissions.CAN_SEE_PUBLIC_LOT_REQUEST_REASON && lot.request.state.DECLINED">
            <textarea class="a-textarea accreditation__textarea"
                      rows="8"
                      disabled
                      :value="lot.request.regulationsReason"
                      placeholder="Тексты пунктов">
            </textarea>
          </div>

          <!-- attach protocol -->
          <div class="a-container-form not-implemented">
            <div class="a-label a-label--w-280"></div>
            <button class="gui-btn gui-btn--red">Прикрепить выписку из протокола</button>
          </div>

          <!-- grant editing -->
          <div class="a-container-form not-implemented">
            <button class="gui-btn gui-btn--red">Разрешить редактирование</button>
          </div>

          <div class="a-container-form" v-if="lot.request.state.CONDITIONALLY_APPROVED">
            <div class="a-label a-label--w-280">{{$t('form.lot.reason-for-conditional-approval')}}:</div>
            <p class="a-input a-input--disabled ">
              {{lot.request.clarificationRequirement}}
            </p>
          </div>

          <div class="a-container-form" v-if="lot.request.permissions.CAN_NOTIFY_CONDITIONALLY_APPROVED">
            <button class="gui-btn gui-btn--red" @click.prevent="onNotifyAboutConditionalApproveClick">{{$t('form.lot.notify-about-conditional-approval')}}</button>
          </div>
        </div>
      </v-collapse-wrapper>

      <!--<v-collapse-wrapper :active="true">-->
        <div class="a-tab__title-block admin__a-tab admin__a-tab">
          <h3>{{$t('form.lot.required-for-lot-documents')}}</h3>
        </div>
        <div class="admin__a-tab-content admin__a-tab-content--show">
          <files-for-document :lot="lot"></files-for-document>
        </div>
        <div class="u-indent-m-b-40px"></div>
      <!--</v-collapse-wrapper>-->

      <template v-if="lot.request && !lot.request.state.EMPTY && bids.length > 0 && canWatchAllBids">
        <v-collapse-wrapper :active="true">
          <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
               v-collapse-toggle
               v-if="bids.length">
            <h3>{{$t('form.lot.bids')}}</h3>
          </div>
          <div class="admin__a-tab-content admin__a-tab-content--show" v-collapse-content>
            <div class="personal-data__btn-block admin-buy__block-gui-btn a-flex-start" v-for="bid in bids">
              <router-link :to="bid.tab" class="gui-btn gui-btn--red gui-btn--w-184" >{{$t('form.lot.bid', {id: bid.num})}}</router-link>
            </div>
          </div>
        </v-collapse-wrapper>
      </template>

      <v-collapse-wrapper :active="true">
        <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
             v-collapse-toggle>
          <h3>{{$t('form.lot.sending-request')}}</h3>
        </div>
        <request-sending :lot="lot" v-collapse-content></request-sending>
      </v-collapse-wrapper>

      <template v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CLARIFICATION || lot.permissions.CAN_VIEW_PUBlIC_LOT_CLARIFICATION">
        <v-collapse-wrapper :active="true">
          <div class="a-tab__title-block admin__a-tab admin__a-tab--modification-controls"
               v-collapse-toggle>
            <h3>{{$t('form.lot.request-clarification')}}</h3>
          </div>
          <request-clarification :lot="lot" v-collapse-content></request-clarification>
        </v-collapse-wrapper>
      </template>

      <template v-if="lot.permissions.CAN_SEE_PUBLIC_LOT_CHANGE_REQUEST">
        <div class="a-container-form">
          <div class="a-label a-label--w-280">{{$t('form.lot.request-status')}}:</div>

          <dropdown-new ref="requestState"
                        class="a-input-group select-w-260"
                        v-model="lot.request.state"
                        :options="requestStates">
          </dropdown-new>

          <button type="button"
                  class="gui-btn gui-btn--red"
                  :disabled="!isStateChanged"
                  @click="onApproveRequestClick({ verdict: lot.request.state, reason: lot.request.reason, regulationsReason: lot.request.regulationsReason, clarificationRequirement: lot.request.clarificationRequirement })">{{$t('buttons.save')}}</button>

          <label class="a-input a-input--disabled u-red-color u-margin-left-20"
                 v-if="showCheckStatesMessage">
            Проверьте все резолюции в каждом предложении участника
          </label>
        </div>

        <div class="a-container-form" v-if="lot.request.confirmedState">
          <div class="a-label a-label--w-280">{{$t('form.lot.confirmed-request-status')}}:</div>
          <label class="a-input a-input--disabled u-red-color">{{$t(lot.request.confirmedState.label)}}</label>
        </div>

        <template v-if="lot.request.state == enums.RequestState.DECLINED || lot.request.state == enums.RequestState.CONDITIONALLY_APPROVED">
          <div class="a-container-form">
            <div class="a-label a-label--auto">В соответствии с пунктом Регламента ЭТП:</div>
            <regulations-paragraphs-picker class="a-input-group select-w-180"
                                           @input="value => lot.request.regulationsReason = value.join('\n\n')"/>
          </div>

          <div class="a-container-form">
            <textarea class="a-textarea accreditation__textarea"
                      rows="4"
                      disabled
                      :value="lot.request.regulationsReason"
                      placeholder="Тексты пунктов">
            </textarea>
          </div>
        </template>

        <template v-if="lot.request.state == enums.RequestState.DECLINED" >
          <div class="a-container-form" >
            <div class="a-label a-label--auto">В дополнение к регламенту:</div>
            <textarea class="a-textarea accreditation__textarea"
                      rows="2"
                      :placeholder="$t('labels.reason')"
                      :disabled="!isStateChanged"
                      v-model="lot.request.reason">
            </textarea>
          </div>

          <div class="a-container-form" v-if="lot.request.confirmedReason">
            <p class="a-textarea a-textarea--disabled">{{lot.request.confirmedReason}}</p>
          </div>
        </template>

        <template v-if="lot.request.state == enums.RequestState.CONDITIONALLY_APPROVED" >
          <div class="a-container-form">
            <div class="a-label a-label--auto">В дополнение к регламенту:</div>
            <textarea class="a-textarea accreditation__textarea"
                      rows="2"
                      :placeholder="$t('labels.reason')"
                      :disabled="!isStateChanged"
                      v-model="lot.request.clarificationRequirement">
            </textarea>
          </div>

          <div class="a-container-form" v-if="lot.request.confirmedСlarificationRequirement">
            <p class="a-textarea a-textarea--disabled">{{lot.request.confirmedСlarificationRequirement}}</p>
          </div>
        </template>
      </template>

      <approved-changes-history-in-request :lot="lot" :request="lot.request"></approved-changes-history-in-request>

      <changes-history-table :request="lot.request"></changes-history-table>

      <div class="u-indent-m-b-40px"></div>

      <signature-details-dialog ref="signCheck"></signature-details-dialog>
    </v-collapse-group>
</template>

<script>
  import FilesForDocument from './request/FilesForDocument'
  import RequestClarification from './request/RequestClarification'
  import RequestSending from './request/RequestSending'
  import Dropdown from '@/widgets/dropdown'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'
  import RegulationsParagraphsPicker from "../../common/inputs/RegulationsParagraphsPicker";
  import ApprovedChangesHistoryInRequest from "./request/ApprovedChangesHistoryInRequest";
  import ChangesHistoryTable from "./changes-history/ChangesHistoryTable";

  export default {
    props: {
      lot: Object
    },

    components: {
      ApprovedChangesHistoryInRequest,
      RegulationsParagraphsPicker,
      FilesForDocument,
      RequestClarification,
      RequestSending,
      Dropdown,
      SignatureDetailsDialog,
      ChangesHistoryTable
    },

    computed: {
      bids() {
        let tabs = [];

        if (this.lot.permissions.CAN_SEE_PUBLIC_LOT_MY_REQUEST && this.lot.request.bids.length > 0) {
          tabs = this.lot.request.bids.map((b, i) => ({
            tab: 'bid-' + b.id,
            bid: b,
            id: b.id,
            idx: i,
            num: b.num
          }));
        }

        return tabs;
      },

      isStateChanged() {
        return this.lot.request.state.valueOf() != this.lot.request.stateOriginal.valueOf();
      },

      canWatchAllBids() {
        return this.$route.name !== 'purchases-public-lot-alien-bid';
      },

      showCheckStatesMessage() {
        return !this.lot.request.permissions.CAN_APPROVE_REQUEST && !this.lot.request.permissions.CAN_CONDITIONALLY_APPROVE_REQUEST;
      },

      requestStates() {
        return [
          {
            id: this.enums.RequestState.NONE,
            name: 'request-state.empty',
            disabled: true
          },

          {
            id: this.enums.RequestState.APPROVED,
            name: 'request-state.approved',
            disabled: !this.lot.request.permissions.CAN_APPROVE_REQUEST
          },

          {
            id: this.enums.RequestState.DECLINED,
            name: 'request-state.declined',
            disabled: !this.lot.request.permissions.CAN_DECLINE_REQUEST
          },

          {
            id: this.enums.RequestState.CONDITIONALLY_APPROVED,
            name: 'request-state.conditionally-approved',
            disabled: !this.lot.request.permissions.CAN_CONDITIONALLY_APPROVE_REQUEST
          }
        ]
      }
    },

    watch: {
      'lot': {
        handler: function() {
          console.info('updated request state');
          const requestState = this.$refs.requestState;

          if (requestState) {
            requestState.$forceUpdate();
          }
        },
        deep: true
      }
    },

    methods: {
      async onApproveRequestClick(options) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('approveRequest', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              verdict: options.verdict.valueOf(),
              reason: options.verdict == this.enums.RequestState.DECLINED ? options.reason : undefined,
              reglamentReason: options.verdict == this.enums.RequestState.DECLINED || options.verdict == this.enums.RequestState.CONDITIONALLY_APPROVED ? options.regulationsReason : undefined,
              clarificationRequirement: options.verdict == this.enums.RequestState.CONDITIONALLY_APPROVED ? options.clarificationRequirement : undefined
            });
          }
          catch(e) {
            console.error('failed approving request', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onNotifyAboutConditionalApproveClick() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('notifyAboutConditionalApprove', {
              lotId: this.lot.id,
              requestId: this.lot.request.id,
              filename: 'notice'
            });
          }
          catch(e) {
            console.error('unable to notify about conditional approval', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onRequestSignCheckClick(fileId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkRequestSignature', {
              requestId: this.lot.request.id,
              fileId: fileId
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('failed checking request signature', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
